import Accordion from "./blocks/accordion";



const main = {
    init: function() {
        Accordion.init();
    }
};

export default main